import React from 'react';
import { Check, X } from 'lucide-react';
import { SectionWrapper } from './shared/SectionWrapper';
export function Results() {
  const achievements = ['Lograr cutículas más limpias con preparación correcta', 'Mejorar adherencia para reducir levantamientos y desprendimientos', 'Construir mejor la estructura para sets más resistentes y prolijos', 'Trabajar con torno y fresas con criterio para un acabado más fino', 'Dominar sistemas y tendencias para ampliar tu carta de servicios', 'Sentirte más segura set tras set (y esa seguridad se nota cuando cobrás)'];
  const stopDoings = ["Improvisar la preparación y cruzar los dedos para que 'no se levante'", 'Perder tiempo en limado porque la estructura no quedó bien desde el inicio', 'Vivir con miedo a que la clienta te escriba a los 3 días por un desprendimiento', "Sentir que tus sets quedan 'lindos, pero no premium'", 'Tardar tanto que terminás regalando tu trabajo', 'Gastar producto de más por falta de control y procedimiento', "Dudar qué sistema usar (gel/polygel/acrílico) y terminar haciendo 'lo que salga'", 'Sentirte insegura para subir precios porque tu técnica no es consistente'];
  return <>
      <SectionWrapper bg="blush" data-id="element-228">
        <div className="max-w-3xl mx-auto" data-id="element-229">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-warm-dark mb-10 text-center" data-id="element-230">
            Lo que vas a lograr{' '}
            <span className="text-rose italic font-normal text-2xl md:text-3xl block mt-1" data-id="element-231">
              (en resultados reales)
            </span>
          </h2>

          <p className="text-center text-warm-muted mb-8 font-medium" data-id="element-232">
            Con Nails Artist Expert vas a poder:
          </p>

          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-cream mb-8" data-id="element-233">
            <ul className="space-y-5" data-id="element-234">
              {achievements.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-235">
                  <div className="bg-success/10 p-1.5 rounded-full shrink-0 mt-0.5" data-id="element-236">
                    <Check className="w-5 h-5 text-success" strokeWidth={2.5} data-id="element-237" />
                  </div>
                  <span className="text-warm-dark font-medium leading-relaxed" data-id="element-238">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="text-center bg-rose/5 border border-rose/20 rounded-xl p-6" data-id="element-239">
            <p className="text-xl font-serif font-bold text-rose" data-id="element-240">
              Traducción real: menos retrabajo, más consistencia, más nivel.
            </p>
          </div>
        </div>
      </SectionWrapper>

      <SectionWrapper bg="cream" data-id="element-241">
        <div className="max-w-3xl mx-auto" data-id="element-242">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-warm-dark mb-10 text-center" data-id="element-243">
            Después de esto, vas a dejar de…
          </h2>

          <div className="grid gap-4" data-id="element-244">
            {stopDoings.map((item, idx) => <div key={idx} className="flex items-start gap-4 bg-white p-5 rounded-xl shadow-sm border border-blush" data-id="element-245">
                <div className="bg-rose/10 p-1.5 rounded-full shrink-0 mt-0.5" data-id="element-246">
                  <X className="w-5 h-5 text-rose" strokeWidth={2.5} data-id="element-247" />
                </div>
                <span className="text-warm-muted font-medium" data-id="element-248">{item}</span>
              </div>)}
          </div>
        </div>
      </SectionWrapper>
    </>;
}